import { P2GGrid, P2GIcon, SvgMagnify, SvgPrePay } from '@parcel2go/core-ui';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { SettingsCache } from '~/lib/consts/settings-cache';
import ActionMenu from '~/apps/smartsend/components/ActionMenu';
import SearchTrigger from '~/apps/smartsend/components/search/SearchTrigger';
import PrePayQuickList from '~/apps/prepay/prepay-quick-list';

interface props {
  isXs: boolean;
  showNav?: boolean;
  currentPageRoute: string;
}

// Header actions for the consumer account experience. Mirrors the relevant slice of
// DashActions: the Order Search drawer (desktop, when the customer has the Search
// feature) plus the mobile quick-links drawer. No SmartSend-only actions.
export default function ConsumerActions({ isXs, showNav, currentPageRoute }: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <Suspense>
      <P2GGrid container spacing={2} alignContent="center" alignItems="center" classNames="dash-actions">
        {SettingsCache.settings.Features.includes('PrePay') && (
          <P2GGrid item flexShrink={1}>
            <PrePayQuickList
              label={
                isXs ? (
                  <P2GIcon size="sm" palette="primary">
                    <SvgPrePay />
                  </P2GIcon>
                ) : (
                  t('SUBNAV_PREPAY_BUTTON', { defaultValue: 'PrePay' })
                )
              }
              title={t('SUBNAV_PREPAY_BUTTON', { defaultValue: 'PrePay' })}
            />
          </P2GGrid>
        )}

        {SettingsCache.settings.Features.includes('Search') && (
          <P2GGrid item flexShrink={1}>
            <SearchTrigger
              label={
                isXs ? (
                  <P2GIcon size="sm" palette="primary">
                    <SvgMagnify />
                  </P2GIcon>
                ) : (
                  t('SUBNAV_ORDER_SEARCH_BUTTON', { defaultValue: 'Order Search' })
                )
              }
            />
          </P2GGrid>
        )}

        {showNav && (
          <P2GGrid item flexShrink={1}>
            <ActionMenu isXs={isXs} currentPageRoute={currentPageRoute} />
          </P2GGrid>
        )}
      </P2GGrid>
    </Suspense>
  );
}
